import { render, staticRenderFns } from "./DuplicateActions.vue?vue&type=template&id=7383b19c&scoped=true"
import script from "./DuplicateActions.vue?vue&type=script&lang=js"
export * from "./DuplicateActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7383b19c",
  null
  
)

export default component.exports